import {$http, Constants} from "@/store/actions/constants";

const url = `${Constants.BaseURL}/company/address`;
export const LocationActions = {

    find: ({commit, state}, search) => {
        return $http.get(url, {...state.authHeader, params: search}).then(r => {
            if (r.status === 200) {
                commit("SET_LOCATIONS", r.data);
            } else {
                console.error("error fetching locations");
            }
        });
    },

    add: ({commit, state}, data) => {
        return $http.post(url, data, state.authHeader).then(r => {
            if (r.status === 200) {
                commit("SET_LOCATION", r.data);
            }
        });
    },

    delete: ({commit, state}, id) => {
        if (id) {
            return $http.delete(`${url}/${id}`, state.authHeader).then(r => {
                if (r.status === 200) {
                    commit("DELETE_LOCATION", id);
                }
            });
        }
    },

    edit: ({commit, state}, data) => {
        return $http.put(`${url}/${data.id}`, data.data, state.authHeader).then(r => {
            if (r.status === 200) {
                commit("UPDATE_LOCATION", data.data);
            }
        });
    },

    get: ({_, state}, id) => {
        return $http.get(`${url}/${id}`, state.authHeader);
    }

};